import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';

import axios from 'axios'
import { Recommendations, RecommendationSummary } from './Recommendations';
import Header from './Header';
import BodyComp from './BodyComp';
import Login from './Login';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes,
  Navigate,
  Redirect
} from "react-router-dom";
import Crosssell from './Crosssell';
import Clusters from './Clusters';
import Dashboard from './Dashboard';
import { Download } from 'react-bootstrap-icons';
import { Downloads } from './Downloads';
import Recommendation from './Recommendation';
import Maps from './Maps';

import Configuration from './Configuration';
import Jobs from './Jobs';

import {TrendingProducts} from './Products';
import { OutletSimilarity } from './OutletSimilarity';


function getUser(){
  let userInfo = localStorage.getItem("userInfo");
  if(userInfo){
      userInfo = JSON.parse(userInfo);
  }
  return userInfo;
}


function App() {

  const isLoggedIn = localStorage.getItem('userInfo');

  const isTokenVerified = true;
  const {selectedScreen,setSelectedScreen}=useState(window.location.pathname);

  const [user,setUser] = useState(getUser())

  
const ProtectedRoute=({ component: Component , user, ...rest })=> {
    let userInfo = localStorage.getItem("userInfo");
    if(userInfo){
      userInfo = JSON.parse(userInfo);
    }
    const isLogged = userInfo?.loginId;

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return isLogged? <Component user {...rest}  /> : <Navigate to="/login" />;
}

function ProtectedRoute1({ component: Component, ...restOfProps }) {
  const { user, loadingUser } = {};

  if (loadingUser) {
    return <p>Loading..</p>;
  }

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        user ? <Component {...props} /> : <Navigate to="/login" />
      }
    />
  );
}

function logout(){
  localStorage.removeItem("userInfo");
  setUser(null);
}
  

  return (
    <>
      <Header user={user} logout={logout} selectedScreen={selectedScreen}/>

      <Router>
        <Routes>

        <Route exact path='/home' element={<ProtectedRoute component={Dashboard}/>}/>
        <Route exact path="/" element={<ProtectedRoute component={Dashboard}/>} />
        <Route exact path="/crosssell" element={<ProtectedRoute component={Crosssell}/>} />
        <Route exact path="/recommendations" element={<ProtectedRoute component={Recommendation}/>} />
        <Route exact path="/maps" element={<ProtectedRoute component={Maps}/>} />

        <Route exact path="/clusters" element={<ProtectedRoute component={Clusters}/>} />
        <Route exact path="/downloads" element={<ProtectedRoute component={Downloads}/>} />
        <Route exact path="/config" element={<ProtectedRoute component={Configuration}/>} />
        <Route exact path="/jobs" element={<ProtectedRoute component={Jobs}/>} />
        <Route exact path="/trending" element={<ProtectedRoute component={TrendingProducts}/>} />
        <Route exact path="/similaroutlets" element={<ProtectedRoute component={OutletSimilarity}/>} />

        
        <Route  path="/login"
            element={<Login setUser={setUser} />}  />

         
        </Routes>
      </Router>


    </>
  );

}

// <div>
//       <Header/>
//       {isLoggedIn
//         ?
//           <BodyComp/>
//         : <Login/>
//       }

// </div>

export default App;
